import { getEnvName } from '@disco/constants/environment'

let __DEV__ = false
let API_HOST = ''
let API_HOST_LAMBDA = ''
let RECAPTCHA_SITE_KEY = ''

if (typeof window !== 'undefined') {
  API_HOST = document.location.port
    ? `${document.location.protocol}//${document.location.hostname}:${document.location.port}`
    : `${document.location.protocol}//${document.location.hostname}`

  switch (getEnvName()) {
    case 'prod':
      __DEV__ = false
      // TODO: migrate signup.disco.ac and then remove API_HOST_LAMBDA
      // https://app.asana.com/0/171564236561515/1200330466221559/f
      API_HOST_LAMBDA = 'https://leveltwo.disco.ac'
      RECAPTCHA_SITE_KEY = '6LdmrRQtAAAAANY0gKUj93gnldIBxttImvX0Pa6G'
      break
    case 'staging':
    default:
      __DEV__ = true
      API_HOST_LAMBDA = API_HOST
      RECAPTCHA_SITE_KEY = '6LdzxBQtAAAAAJq7NHAqCugJgG9HcskfJCNLfuXJ'
      break
  }
}
export { __DEV__, API_HOST, API_HOST_LAMBDA, RECAPTCHA_SITE_KEY }
